import React, { useState } from 'react';
import './OtsCloseHeaderCard.scss';
import { ClosedSortingParams, SortField, SortOrder } from '../../../Models/ClosedSearchParams';
import { useDispatch, useSelector } from 'react-redux';
import { setSorting } from '../../../store/feature/ClosedFilterSortSlice';

export const OtsCloseHeaderCard = ({ onSortChange }: {
  onSortChange: () => void,
}) => {
  const dispatch = useDispatch();
  const sectionheaders = [
    { name: 'Aircraft #', className: 'header-item', id: 'aircraft', sortField: SortField.AircraftRegistration },
    { name: 'Station', className: 'header-item',  id: 'station', sortField: SortField.Station },
    { name: 'OTS start time', className: 'header-item',  id: 'start-time', sortField: SortField.OTSStartTime }
  ];
  const currentSort:ClosedSortingParams = useSelector((state: any) => state.closedFilterSort.sorting);

  const handleHeaderClick = (index: number) => {
    const closedSelectedHeader = sectionheaders.findIndex(header => header.sortField === currentSort.sortBy);
    let sortOrder;
    if (closedSelectedHeader !== index) {
      sortOrder = SortOrder.Asc;
    } else {
      sortOrder = currentSort.sortOrder === SortOrder.Asc ? SortOrder.Desc : SortOrder.Asc;
    }
    // set redux and call the onSortChange function
    dispatch(setSorting({ sortBy: sectionheaders[index].sortField, sortOrder: sortOrder }));
    onSortChange();
  };

  return (
    <><div className="ots-close-header-card">
      <div className="close-horizontal-header-section">
        {sectionheaders.map((header, index) => (
          <div
            className='column'
            key={header.id}
            id={header.id}
          >
            <div
              className={header.className}
              onClick={() => handleHeaderClick(index)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === ' ') {
                  handleHeaderClick(index);
                }
              }}
            >
              <div className={currentSort.sortBy === header.sortField ? 'header-text-selected' : 'header-text'}>{header.name}</div>
              {currentSort.sortBy === header.sortField && <div className="header-underline"></div>}
            </div>
          </div>
        ))}
      </div>
    </div></>
  );

}

export default OtsCloseHeaderCard;
